module.exports = __webpack_public_path__ + "static/img/blog_good_10.b34a888.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_good_10.png
// module id = qYLB
// module chunks = 8